import { useSelector } from 'react-redux';
import { useState, useEffect } from 'react';

import { Box, TextField, Typography, Autocomplete } from '@mui/material';

import { useAppDispatch } from 'src/context/store';
import { anonymous_citiesFunc } from 'src/context/cities/anonymous_cities';

interface ICitiesItemProps {
  name: string;
  districts: string[];
}

export const CityFilter = (props: { filters: any; setFilters: React.Dispatch<any> }) => {
  const dispatch = useAppDispatch();
  const cities = useSelector((state: any) => state.anonymous_cities);
  const [citiesData, setCitiesData] = useState([] as ICitiesItemProps[]);
  const [selectedCity, setSelectedCity] = useState<ICitiesItemProps | undefined>(undefined);
  const [selectedDistricts, setSelectedDistricts] = useState<string>('');
  const districtData = selectedCity?.districts || [];

  const normalizeText = (value: string | null | undefined) =>
    (value || '').trim().toLocaleLowerCase('tr-TR');

  useEffect(() => {
    if (dispatch) {
      dispatch(anonymous_citiesFunc());
    }
  }, [dispatch]);

  useEffect(() => {
    const anonymousCitiesData = cities?.anonymous_citiesData?.data;

    setCitiesData(anonymousCitiesData);
  }, [cities]);

  useEffect(() => {
    const cityFromFilters = props.filters?.location?.city;

    if (!cityFromFilters) {
      setSelectedCity(undefined);
      return;
    }

    const foundCity = citiesData?.find(
      (c) => normalizeText(c.name) === normalizeText(cityFromFilters)
    );
    setSelectedCity(foundCity);
  }, [props.filters?.location?.city, citiesData]);

  useEffect(() => {
    const districtFromFilters = props.filters?.location?.district;

    if (!districtFromFilters) {
      setSelectedDistricts('');
      return;
    }

    const foundDistrict = districtData?.find(
      (d) => normalizeText(d) === normalizeText(districtFromFilters)
    );
    setSelectedDistricts(foundDistrict || districtFromFilters);
  }, [props.filters?.location?.district, districtData]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
        Konum
      </Typography>

      <Autocomplete
        id="city-search-input"
        clearIcon={null}
        disableClearable={false}
        options={citiesData}
        value={selectedCity}
        isOptionEqualToValue={(option, value) => option?.name === value?.name}
        getOptionLabel={(option) => option?.name || ''}
        renderInput={(params) => (
          <TextField
            {...params}
            label="İl"
            slotProps={{
              input: {
                ...params.InputProps,
                type: 'search',
              },
            }}
            size="small"
            sx={{
              mb: 1,
              '& .MuiInputBase-root': {
                borderRadius: '100px',
              },
              '& .MuiInputBase-input': {
                fontSize: 12,
              },
            }}
          />
        )}
        onChange={(event, newValue) => {
          setSelectedCity(newValue || undefined);
          props.setFilters((prev: any) => ({
            ...prev,
            location: {
              ...prev.location,
              city: newValue?.name || null,
              district: null,
            },
          }));
        }}
      />

      <Autocomplete
        id="district-search-input"
        clearIcon={null}
        disableClearable={false}
        options={districtData ?? []}
        value={selectedDistricts}
        getOptionLabel={(option) => option || ''}
        renderInput={(params) => (
          <TextField
            {...params}
            label="İlçe"
            slotProps={{
              input: {
                ...params.InputProps,
                type: 'search',
              },
            }}
            size="small"
            sx={{
              mb: 1,
              '& .MuiInputBase-root': {
                borderRadius: '100px',
              },
              '& .MuiInputBase-input': {
                fontSize: 12,
              },
            }}
          />
        )}
        onChange={(event, newValue) => {
          setSelectedDistricts(newValue || '');
          props.setFilters((prev: any) => ({
            ...prev,
            location: {
              ...prev.location,
              city: selectedCity?.name || null,
              district: newValue || null,
            },
          }));
        }}
      />
    </Box>
  );
};
